module.exports = __webpack_public_path__ + "img/Aegis.0634ebf6.png";